import { Box } from '../Common/Box';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext, useMemo } from 'react';
import { PaymentMethodEnum } from '@/types/common';
import { DrawerScreen } from '@/types/screens';
import { getOtherPaymentMethods } from '@/utils/paymentMethods';
import OtherPaymentMethodLogo from '@/assets/icons/common/other.svg';
import { useTranslate } from '@/hooks/useTranslate';
import { useScreenSurface } from '@/hooks/useScreenSurface';

export const OtherPaymentMethod = () => {
  const { paymentMethodSelected, paymentMethodsAvailable } = useContext(CheckoutContext);
  const { openScreen } = useScreenSurface();
  const { t } = useTranslate();

  const otherPaymentMethods = useMemo(() => getOtherPaymentMethods(paymentMethodsAvailable), [paymentMethodsAvailable]);
  const isSelected = useMemo(
    () =>
      paymentMethodSelected === PaymentMethodEnum.OTHER ||
      otherPaymentMethods.some((pm) => pm.paymentMethodName === paymentMethodSelected),
    [paymentMethodSelected, otherPaymentMethods]
  );

  const handleSelect = () => openScreen(DrawerScreen.OTHER_PAYMENT_METHOD);

  return (
    <Box isSelected={isSelected} onSelect={handleSelect}>
      <div className="flex flex-row items-center gap-1">
        <img src={OtherPaymentMethodLogo} alt="other" />
        <div className="text-xs color-base-foreground">{t('other')}</div>
      </div>
    </Box>
  );
};
